import React from 'react';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Label,
  UncontrolledDropdown,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CheckboxDropdown = ({
  dropdownCheck: {
    banned,
    images,
    items,
    potentiallyBanned,
    restricted,
    unpublished,
  },
  handleCheckboxAll,
  handleDropdownMessage,
  selectedLots,
  isBanned,
  isPotentiallyBanned,
  isRestricted,
  isUnpublished,
  noImage }) => (
    <UncontrolledDropdown size="sm">
      <DropdownToggle caret color="white" className="border-0" aria-label="Dropdown Filter">
        {selectedLots.size > 0 ? (
          <FontAwesomeIcon
            className="color-blue cursor-pointer"
            icon="minus-square"
            onClick={() => handleCheckboxAll()}
          />
        ) : (
          <Label check>
            <Input
              className="m-0 position-relative"
              type="checkbox"
              checked={selectedLots.size > 0}
              aria-label="Dropdown Checkbox"
              onChange={() => handleCheckboxAll()}
            />
          </Label>
        )}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleDropdownMessage('items')}>{items && 'Unselect '}All Items</DropdownItem>
        {isUnpublished && <DropdownItem onClick={() => handleDropdownMessage('unpublished')}>{unpublished && 'Deselect '}Unpublished</DropdownItem>}
        {isBanned && <DropdownItem onClick={() => handleDropdownMessage('banned')}>{banned && 'Deselect '}Banned</DropdownItem>}
        {isPotentiallyBanned && <DropdownItem onClick={() => handleDropdownMessage('potentiallyBanned')}>{potentiallyBanned && 'Deselect '}Potentially Banned</DropdownItem>}
        {isRestricted && <DropdownItem onClick={() => handleDropdownMessage('restricted')}>{restricted && 'Deselect '}Payment Restricted</DropdownItem>}
        {noImage && <DropdownItem onClick={() => handleDropdownMessage('images')}>{images && 'Deselect '}Items Without Images</DropdownItem>}
      </DropdownMenu>
    </UncontrolledDropdown>
);

export default CheckboxDropdown;
